import React from 'react';
import View  from '@widesk-ui/components/View';

const HeaderButton = (props: {
	icon: React.ReactNode;
	children: React.ReactNode;
	active?: boolean;
	onClick?: () => void;
}) => (
	<View
		row
		center
		gap={6}
		h={32}
		px={12}
		color={props.active ? '#66B2FF' : 'white'}
		style={{
			borderRadius: 6,
			border: `1px solid ${props.active ? '#66B2FF' : 'rgba(255,255,255,0.32)'}`,
			cursor: 'pointer',
			fontSize: 13,
			fontWeight: 600,
		}}
		onClick={props.onClick}
	>
		{props.icon}
		{props.children}
	</View>
);

export default HeaderButton;
